module.exports = __webpack_public_path__ + "static/media/logo.59f3a2eb.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/logo.png
 ** module id = 55
 ** module chunks = 0
 **/